<template>
  <Card :title="$t('setting.title')" containerClass="mb-5">
    <template #cardBody>
      <RequiredText />
      <ul class="nav nav-tabs nav-line-tabs mb-5 fs-6">
        <li class="nav-item" v-if="$canAccess(moduleAbilities.CRM_INVOICE)">
            <a class="nav-link active" data-bs-toggle="tab" href="#kt_tab_pane_1">{{$t('menu.crm.invoices')}}</a>
        </li>
        <li class="nav-item" v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)">
            <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_2">{{$t('menu.crm.devis')}}</a>
        </li>
        <li class="nav-item" v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)">
            <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_3">{{$t('menu.crm.payment')}}</a>
        </li>
        <li class="nav-item" v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)">
            <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_4">{{$t('crm.advances.title')}}</a>
        </li>
        <li class="nav-item" v-if="$canAccess(moduleAbilities.CUSTOMER_NPS)">
          <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_5">{{$t('crm.advances.nps')}}</a>
        </li>
        <li class="nav-item" v-if="$canAccess(moduleAbilities.EVENT_PORTAL)">
          <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_6">{{$t('events.title')}}</a>
        </li>
      </ul>

      <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="kt_tab_pane_1" role="tabpanel" v-if="$canAccess(moduleAbilities.CRM_INVOICE)">
            <div class="row">
              <div 
                v-for="mail in mailInvoice" 
                :key="mail.id" 
                class="col-md-12 col-12"
              >
                <email-system 
                  :id="`mail-invoice-${mail.id}`" 
                  :name="mail.type"
                  :mail="mail.content"
                  :mail-id="mail.id"
                  :mailEnum="mailEnum['INVOICE']"
                ></email-system>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="kt_tab_pane_2" role="tabpanel" v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)">
            <div class="row">
              <div 
                v-for="mail in mailEstimate" 
                :key="mail.id" 
                class="col-md-12 col-12"
              >
                <email-system 
                  :id="`mail-devis-${mail.id}`" 
                  :name="mail.type"
                  :mail="mail.content"
                  :mail-id="mail.id"
                  :mailEnum="mailEnum['ESTIMATE']"
                ></email-system>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="kt_tab_pane_3" role="tabpanel" v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)">
            <div class="row">
              <div 
                v-for="mail in mailPayment" 
                :key="mail.id" 
                class="col-md-12 col-12"
              >
                <email-system 
                  :id="`mail-payment-${mail.id}`" 
                  :name="mail.type"
                  :mail="mail.content"
                  :mail-id="mail.id"
                  :mailEnum="mailEnum['PAYMENT']"
                ></email-system>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="kt_tab_pane_4" role="tabpanel" v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)">
            <div class="row">
              <div 
                v-for="mail in mailAdvance" 
                :key="mail.id" 
                class="col-md-12 col-12"
              >
                <email-system 
                  :id="`mail-advance-${mail.id}`" 
                  :name="mail.type"
                  :mail="mail.content"
                  :mail-id="mail.id"
                  :mailEnum="mailEnum['ADVANCE']"
                ></email-system>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel"  v-if="$canAccess(moduleAbilities.CUSTOMER_NPS)">
            <div class="row">
              <div
                  v-for="mail in mailNps"
                  :key="mail.id"
                  class="col-md-12 col-12"
              >
                <email-system
                    :id="`mail-nps-${mail.id}`"
                    :name="mail.type"
                    :mail="mail.content"
                    :mail-id="mail.id"
                    :mailEnum="mailEnum['NPS']"
                ></email-system>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel" v-if="$canAccess(moduleAbilities.EVENT_PORTAL)">  
            <div class="row">
              <div
                  v-for="mail in mailEvents"
                  :key="mail.id"
                  class="col-md-12 col-12"
              >
                <email-system
                    :id="`mail-event-${mail.id}`"
                    :name="mail.type"
                    :mail="mail.content"
                    :mail-id="mail.id"
                    :mailEnum="mailEnum['EVENT']"
                ></email-system>
              </div>
            </div>
          </div>
      </div>
      
    </template>
  </Card>
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import {onMounted,computed} from 'vue'
import {useStore} from "vuex";
import EmailSystem from "./EmailSystem.vue";
import RequiredText from "@/components/RequiredText"
import moduleAbilities from "@/composables/moduleAbilities";

const store = useStore()

const mailMessage = computed(() => store.getters['mail/getMailMessage'])
const mailEnum = computed(() => store.getters['mail/getEmailEnum'])

const mailInvoice = computed(() => mailMessage.value?.filter(item => item.type && item.type.value?.includes('INVOICE') && !item.type.value?.includes('ADVANCE')) || [])

const mailEstimate = computed(() => mailMessage.value?.filter(item => item.type && item.type.value?.includes('ESTIMATE')) || [])

const mailPayment = computed(() => mailMessage.value?.filter(item => item.type && item.type.value?.includes('PAYMENT')) || [])

const mailAdvance = computed(() => mailMessage.value?.filter(item => item.type && item.type.value?.includes('ADVANCE')) || [])

const mailNps = computed(() => mailMessage.value?.filter(item => item.type && item.type.value?.includes('NPS')) || [])

const mailEvents = computed(() => mailMessage.value?.filter(item => item.type && item.type.value?.includes('EVENT')) || [])


onMounted(() => {
 loadMailMessage()
 store.dispatch('mail/loadEnumEmailMessage')
})

const loadMailMessage = async () => {
  try {
    await store.dispatch('mail/loadMailMessage') 
    
  }catch (e) {
  }
}
</script>

<style scoped>
  .nav-line-tabs .nav-item .nav-link.active, .nav-line-tabs .nav-item .nav-link:hover:not(.disabled), .nav-line-tabs .nav-item.show .nav-link {
    background-color: transparent;
    border: 0;
    border-bottom: 2px solid var(--bs-primary);
    color: var(--bs-primary);
    transition: color .2s ease, background-color .2s ease;
  }
  .nav-line-tabs .nav-item .nav-link {
    color: #000;
    border: 0;
    border-bottom: 1px solid transparent;
    transition: color .2s ease, background-color .2s ease;
    padding: 0.5rem 0;
    margin: 0 1rem;
  }
</style>